import QRCode from 'react-qr-code';

export const LiveQR = ({ url, size = 168, caption = 'Escanea para pedir y votar en vivo' }) => {
  return (
    <div
      className="relative rounded-xl border bg-card p-6 shadow-sm"
      data-testid="live-qr-card"
    >
      {/* Decorative gradient background */}
      <div className="absolute inset-0 -z-10 rounded-xl bg-[radial-gradient(60%_60%_at_30%_20%,rgba(0,245,160,0.12),transparent)]"></div>
      
      {/* QR Code */}
      <div className="bg-white p-4 rounded-lg inline-block">
        <QRCode
          value={url}
          size={size}
          bgColor="#ffffff"
          fgColor="#0b0f14"
          level="M"
        />
      </div>
      
      {/* Caption */}
      {caption && (
        <p
          className="mt-3 text-sm text-muted-foreground text-center"
          data-testid="live-qr-caption"
        >
          {caption}
        </p>
      )}
    </div>
  );
};
